import styled from 'styled-components'
import { media } from '../../../utils'

const TopInfoContainer = styled.div`
  position: relative;
  grid-area: info;
  align-self: center;
  width: 100%;
  padding: 0px 10px;

  .awards {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ${media.tablet`
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `}

    .star-containers {
      color: #4a4a4a;
      font-family: 'Montserrat', Sans-serif;
      font-weight: 400;
      margin-top: 0;
      margin-bottom: 0.9rem;
      text-align: left;
      font-size: 16px;
      ${media.tablet`
        text-align: center;
      `}
    }

    .image-containers {
      display: flex;
      justify-content: center;
      padding-bottom: 15px;
      ${media.tablet`
        width: 100%;
      `}
      img {
        max-width: 100px;
        max-height: 70px;
        margin: auto;
        padding: 0 7.5px;
      }
    }
  }

  .container {
    background-color: #cef1d8;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s;
    width: 100%;
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    h2 {
      font-family: 'Montserrat', Sans-serif;
      font-size: 23px;
      font-weight: 600;
      margin-top: 0.9rem;
      margin-bottom: 1.5rem;
    }
    p {
      font-family: 'Montserrat', Sans-serif;
      font-size: 16px;
      font-weight: 400;
      margin-top: 0;
    }
    ul {
      list-style-type: none;
      margin: 0;
      padding-left: 20px;

      li {
        margin-bottom: 7.5px;
        font-family: 'Montserrat', Sans-Serif;
        font-size: 16px;
        color: #4a4a4a;
      }
    }
    img {
      display: block;
      max-width: 200px;
      margin: 0px 20px;
      ${media.desktop`
        display: block;
        max-width: 200px;
        margin: 0px 15px;
      `}
      ${media.tablet`
        display: none;
      `}
    }
  }
`
export default TopInfoContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/TopInfoContainer.tsx